

import React, {Component} from 'react'
import { connect } from 'react-redux'
import Category from './components/category/Category'


class CategoriesBar extends Component 
{
    render()
    {
        var categoryComponents = [];

        let categories = this.props.saleContext.primaryMenu.categories;
        for (var index = 0; index < categories.length; index++)
        {
            let category = categories[index];
            categoryComponents.push(<Category category={category} isSelected={this.props.saleContext.selectedCategory == category}/>);
        }

        return (<div style={{display:'flex', flexWrap:'wrap', 
                             padding:'12px', 
                             borderBottom:'1px solid var(--colors-neutral)',
                             gap:"4px"}}>
                    {categoryComponents}
                </div>)
    }
}

const mapStateToProps = state => 
{
    return { 
                saleContext: state.saleContext,
                menuChangedDateTime: state.saleContext.menuChangedDateTime
           }
}

export default connect(mapStateToProps)(CategoriesBar)